module.exports = __webpack_public_path__ + "img/chinesecompany11.afe701a5.png";